import styled from '@emotion/styled';
import { Icon } from '@mdi/react';
import { Variables } from '../../base';
import { ComposeInput, IComposeInputProps } from './compose-input';
import { ComposeTextarea, IComposeTextareaProps } from './compose-textarea';
import { ClaimsManager } from '../claims-manager';

export const Header = styled.div`
    display: flex;
    align-items: center;
    box-shadow: ${Variables.Shadows.border};
    background-color: ${Variables.ThemeLight.Background2};
    padding: 20px 20px 16px 32px;
`;

export const Title = styled.div`
    display: inline-flex;
    flex-grow: 1;
    font-size: ${Variables.FontSizes.large};
    font-weight: ${Variables.FontWeight.semibold};
    line-height: 100%;
    letter-spacing: 0%;
    color: ${Variables.ThemeLight.TextStrong};
`;
export const CloseButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: none;
    padding: 0;
    cursor: pointer;
    color: ${Variables.Colors.n50};
    transition: color 0.2s ease;

    &:hover {
        color: ${Variables.Colors.n70};
    }
`;
export const CloseIcon = styled(Icon)`
    fill: ${Variables.Colors.n30};
`;

interface IBodyProps {
    isNote?: boolean;
}
export const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;
export const Label = styled.div`
    font-family: ${Variables.Fonts.calibre};
    font-size: ${Variables.FontSizes.tiny};
    font-weight: ${Variables.FontWeight.medium};
    color: ${Variables.ThemeLight.TextMedium};
    letter-spacing: 0%;
    line-height: 100%;
`;
export const Body = styled.div<IBodyProps>`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    padding: 32px;
    overflow-y: auto;

    ${(props: IBodyProps) =>
        props.isNote &&
        `
        background: linear-gradient(180deg, ${Variables.ThemeLight.NeutralMild2} 0%, ${Variables.ThemeLight.Background2} 100%);
    `}

    & > * {
        margin: 8px 0;
    }

    input,
    textarea,
    .select__control {
        border: 1px solid ${Variables.ThemeLight.Border3};
        border-radius: 4px;
        font-size: ${Variables.FontSizes.tiny};
        font-weight: ${Variables.FontWeight.regular};
        color: ${Variables.ThemeLight.TextMedium};
        background-color: ${Variables.ThemeLight.Background3};
        &::placeholder {
            color: ${Variables.ThemeLight.TextXMild};
            font-size: ${Variables.FontSizes.tiny};
            font-weight: ${Variables.FontWeight.regular};
        }
    }

    input:hover,
    textarea:hover,
    .select__control:hover {
        border-color: ${Variables.Swatches.Blue4};
    }

    input:focus,
    input:active,
    textarea:focus,
    textarea:active,
    select:focus,
    .select__control--is-focused {
        border: 1px solid ${Variables.Swatches.Blue4} !important;
        box-shadow: none !important;
        outline: none;
    }
`;

export const StyledComposeInput = styled(ComposeInput)<IComposeInputProps>`
    margin-top: 16px;
`;

export const StyledComposeTextarea = styled(ComposeTextarea)<IComposeTextareaProps>`
    margin-top: 16px;
`;

export const TemplateRow = styled.div`
    display: flex;
    gap: 8px;
    max-height: 56px;
`;

export const TemplateColumn = styled.div`
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
`;

export const StyledMessageFields = styled.div`
    /* Override the horizontal padding from FieldRow elements inside MessageFields */
    & > div {
        padding-left: 0 !important;
        padding-right: 0 !important;
    }
`;

export const StyledClaimsManager = styled(ClaimsManager)`
    margin: 12px 0 !important;
`;

export const PrivateNoteHint = styled.div`
    font-size: ${Variables.FontSizes.tiny};
    font-weight: ${Variables.FontWeight.regular};
    line-height: 140%;
    color: ${Variables.ThemeLight.TextMedium};
    padding: 8px 12px;
    border-radius: 4px;
    background-color: ${Variables.ThemeLight.NeutralMild3};
    border: 1px solid ${Variables.Colors.b300_l90};
`;
